import {IStore} from '../store';

export const savedAlbumIdsSelector: (state: IStore) =>
  ReadonlyArray<string> = (state: IStore) => state.albums.savedAlbumIds;

export const isAlbumSavedSelector: (id: string) => (state: IStore) => boolean = (id: string) => (state: IStore) =>
  savedAlbumIdsSelector(state).includes(id);
